// import React from "react";
// import { Tag } from "antd";
// import { applicationStatus } from "../constants/DataConstants";

// const StatusTag = ({ statusId, statusName }) => {
//     // CASE 1: Only statusId → render Tag
//     if (statusId && !statusName) {
//         const statusObj = applicationStatus.find((s) => s.id === statusId);
//         if (!statusObj) return null;
        
//         const { name, color, textColor } = statusObj;
//         console.log(statusId, "statustag page")
//         console.log(name, "name page")

//         return (
//             <Tag className="status-tag"
//                 style={{
//                     background: color,
//                     color: textColor,
//                 }}
//             >
//                 {name}
//             </Tag>
//         );
//     }

//     if (!statusId && statusName) {
//         const statusObj = applicationStatus && applicationStatus.find((s) => s.id === statusName);
//         if (!statusObj) return null;

//         return <div>{statusObj.name}</div>;
//     }

//     return null;
// };

// export default StatusTag;


import React from "react";
import { Tag } from "antd";
import { applicationStatus } from "../constants/DataConstants";

const StatusTag = ({ statusId, statusName }) => {
    // CASE 1: Only statusId → render Tag
    if (statusId && !statusName) {
        //debugger
        const statusObj = applicationStatus.find((s) => s.id === statusId);
        if (!statusObj) return null;
        
        const { name, color, textColor } = statusObj;
        // console.log(statusId, "statustag page")
        // console.log(name, "name page")

        return (
            <Tag
                style={{
                    background: color,
                    color: textColor,
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 500,
                    fontSize: 16,
                    padding: "4px 12px",
                    height: 28,
                    display: "inline-flex",
                    alignItems: "center",
                }}
            >
                {name}
            </Tag>

        );
    }

    if (!statusId && statusName) {
       // debugger
        const statusObj = applicationStatus && applicationStatus.find((s) => s.id === statusName);
        if (!statusObj) return null;

        return <div>{statusObj.name}</div>;
    }

    return null;
};

export default StatusTag;
